import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupByTournamentId',
})
export class GroupByTournamentId implements PipeTransform {
  transform(value, args: string[]): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          const group = o.TournamentId;
          const icon = o.SportName;
          const tour = o.TournamentName;
          const sno = o.SportNameOriginal;
          const cat = o.CategoryName;
          const grp = o.GroupName;
          const rnk = o.Rank;
          const tourshort = o.TournamentNameShort;
          const cid = o.CategoryId;
          const betradarMatchId = o.BetradarMatchId;
          const sequenceNumber = o.SequenceNumber;
          const sportId = o.SportId;
          const isoName = o.IsoName;
          const betradarTournamentId = o.BetradarTournamentId;
          groups[group] = groups[group]
            ? groups[group]
            : {
                TourShort: tourshort,
                TournamentId: group,
                SportName: icon,
                TournamentName: tour,
                SportNameOriginal: sno,
                CategoryName: cat,
                CatId: cid,
                BetradarMatchId: betradarMatchId,
                BetradarTournamentId: betradarTournamentId,
                SportId: sportId,
                GroupName: grp,
                Rank: rnk,
                SequenceNumber: sequenceNumber,
                IsoName: isoName,
                eEvents: [],
              };
          groups[group].eEvents.push(o);
        });
      }

    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
